const AppPaths = {
  HOME: "/home",
  CHAT_ROOM: "/c/:chatId",
  LOGIN: "/login1",
  SIGN_UP: "/signup1",
};

export default AppPaths;
